"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = ["onSubmit"];
var _hoisted_2 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "heading2" }, "Данные организации", -1);
var _hoisted_3 = { class: "submission-form__inputs" };
var _hoisted_4 = { class: "submission-form__grid-4" };
var _hoisted_5 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "heading2" }, "Контактное лицо", -1);
var _hoisted_6 = { class: "submission-form__inputs" };
var _hoisted_7 = { class: "submission-form__grid-2" };
var _hoisted_8 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "heading2" }, "Комментарий к заказу", -1);
var _hoisted_9 = ["placeholder"];
var _hoisted_10 = /*#__PURE__*/ vue_2.createStaticVNode("<div class=\"SubmissionFormBottom submission-form__bottom\"><label class=\"checkbox-radio\"><input type=\"checkbox\" name=\"personality\" checked class=\"required\" title=\"Согласие на обработку персональных данных\"><div class=\"checkbox\"><i class=\"termi-circle-checkmark\"></i></div> Я согласен на  <a href=\"/terms/\" class=\"link\">обработку персональных данных</a></label><button type=\"submit\" class=\"default-btn submission-form__submit\">Оформить заказ</button></div>", 1);
var _hoisted_11 = {
    key: 0,
    class: "form-errors"
};
var vue_3 = require("vue");
var DeliveryType_vue_1 = require("@/components/SubmissionForm/DeliveryType.vue");
var RadioButtons_vue_1 = require("@/components/SubmissionForm/RadioButtons.vue");
var helpers_1 = require("vue_components/helpers");
var InputContainer_vue_1 = require("vue_components/InputContainer.vue");
var vuex_1 = require("vuex");
exports.default = vue_1.defineComponent({
    emits: ['checkout'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var store = vuex_1.useStore();
        var form = vue_3.ref({
            person_type: { value: 'org' },
            name: {
                placeholder: 'ФИО',
                required: true,
                value: ''
            },
            phone: {
                type: 'tel',
                pattern: helpers_1.inputProperties.tel.pattern,
                placeholder: '+7 (XXX) XXX-XX-XX',
                required: true,
                value: ''
            },
            email: {
                placeholder: 'E-mail',
                pattern: helpers_1.inputProperties.email.pattern,
                type: 'email',
                required: true,
                value: ''
            },
            delivery_type: {
                placeholder: 'Тип доставки',
                required: true,
                value: ''
            },
            delivery_address: {
                placeholder: 'Адрес доставки',
                value: ''
            },
            pay_type: {
                required: true,
                placeholder: 'Оплата',
                value: ''
            },
            comment: {
                placeholder: 'Ваш комментарий...',
                value: ''
            },
            company_name: {
                required: true,
                placeholder: 'Наименование организации',
                value: '',
            },
            inn: {
                placeholder: 'ИНН',
                required: true,
                value: ''
            },
            kpp: {
                placeholder: 'КПП',
                required: true,
                value: ''
            },
            orgn: {
                placeholder: 'ОРГН',
                required: true,
                value: ''
            },
            bik: {
                placeholder: 'БИК',
                required: true,
                value: ''
            },
            r_s: {
                placeholder: 'р/с',
                required: true,
                value: ''
            },
            jur_address: {
                value: ''
            },
            fac_address: {
                value: ''
            }
        });
        var pay_types = vue_3.computed(function () {
            var pay_prop = store.state.formData.pay_prop;
            var arr = [];
            for (var key in pay_prop) {
                arr.push({
                    name: 'pay_type',
                    value: pay_prop[key].id,
                    placeholder: pay_prop[key].value
                });
            }
            return arr;
        });
        vue_3.watch(function () { return store.state.user; }, function (user) {
            form.value.name.value = user.name;
            form.value.phone.value = user.phone;
            form.value.email.value = user.email;
            form.value.company_name.value = user.main_company.company_name;
            form.value.inn.value = user.main_company.inn;
            form.value.kpp.value = user.main_company.kpp;
            form.value.orgn.value = user.main_company.orgn;
            form.value.bik.value = user.main_company.bik;
            form.value.r_s.value = user.main_company.r_s;
        }, { deep: true, immediate: true });
        var formErrors = vue_3.ref([]);
        function submit() {
            return __awaiter(this, void 0, void 0, function () {
                var formData;
                return __generator(this, function (_a) {
                    formErrors.value.length = 0;
                    helpers_1.validateForm(form.value, formErrors.value);
                    if (formErrors.value.length)
                        throw new Error(formErrors.value);
                    formData = helpers_1.formToFormData(form.value);
                    emit('checkout', { formData: formData, errors: formErrors.value, address_saved: address_saved.value });
                    return [2 /*return*/];
                });
            });
        }
        var address_saved = vue_3.ref(false);
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("form", {
                class: "submission-form",
                onSubmit: vue_2.withModifiers(submit, ["prevent"])
            }, [
                _hoisted_2,
                vue_2.createElementVNode("div", _hoisted_3, [
                    vue_2.createVNode(InputContainer_vue_1.default, {
                        name: "inn",
                        placeholder: form.value.company_name.placeholder,
                        type: form.value.company_name.type,
                        required: form.value.company_name.required,
                        modelValue: form.value.company_name.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((form.value.company_name.value) = $event); })
                    }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                    vue_2.createElementVNode("div", _hoisted_4, [
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "inn",
                            placeholder: form.value.inn.placeholder,
                            type: form.value.inn.type,
                            required: form.value.inn.required,
                            modelValue: form.value.inn.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((form.value.inn.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "kpp",
                            placeholder: form.value.kpp.placeholder,
                            type: form.value.kpp.type,
                            required: form.value.kpp.required,
                            modelValue: form.value.kpp.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((form.value.kpp.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "orgn",
                            placeholder: form.value.orgn.placeholder,
                            type: form.value.orgn.type,
                            required: form.value.orgn.required,
                            modelValue: form.value.orgn.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((form.value.orgn.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "bik",
                            placeholder: form.value.bik.placeholder,
                            type: form.value.bik.type,
                            required: form.value.bik.required,
                            modelValue: form.value.bik.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((form.value.bik.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "r_s",
                            placeholder: form.value.r_s.placeholder,
                            type: form.value.r_s.type,
                            required: form.value.r_s.required,
                            modelValue: form.value.r_s.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((form.value.r_s.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"])
                    ])
                ]),
                vue_2.createVNode(DeliveryType_vue_1.default, {
                    delivery_address: form.value.delivery_address.value,
                    "onUpdate:delivery_address": _cache[6] || (_cache[6] = function ($event) { return ((form.value.delivery_address.value) = $event); }),
                    delivery_type: form.value.delivery_type.value,
                    "onUpdate:delivery_type": _cache[7] || (_cache[7] = function ($event) { return ((form.value.delivery_type.value) = $event); }),
                    address_saved: address_saved.value,
                    "onUpdate:address_saved": _cache[8] || (_cache[8] = function ($event) { return ((address_saved).value = $event); })
                }, null, 8, ["delivery_address", "delivery_type", "address_saved"]),
                _hoisted_5,
                vue_2.createElementVNode("div", _hoisted_6, [
                    vue_2.createVNode(InputContainer_vue_1.default, {
                        name: "name",
                        placeholder: form.value.name.placeholder,
                        modelValue: form.value.name.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((form.value.name.value) = $event); })
                    }, null, 8, ["placeholder", "modelValue"]),
                    vue_2.createElementVNode("div", _hoisted_7, [
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            type: "tel",
                            name: "phone",
                            placeholder: form.value.phone.placeholder,
                            pattern: form.value.phone.pattern,
                            modelValue: form.value.phone.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((form.value.phone.value) = $event); }),
                            required: form.value.phone.required
                        }, null, 8, ["placeholder", "pattern", "modelValue", "required"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "email",
                            placeholder: form.value.email.placeholder,
                            pattern: form.value.email.pattern,
                            type: form.value.email.type,
                            modelValue: form.value.email.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return ((form.value.email.value) = $event); }),
                            required: form.value.email.required
                        }, null, 8, ["placeholder", "pattern", "type", "modelValue", "required"])
                    ])
                ]),
                vue_2.createVNode(RadioButtons_vue_1.default, {
                    modelValue: form.value.pay_type.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((form.value.pay_type.value) = $event); }),
                    title: "Оплата",
                    items: vue_2.unref(pay_types),
                    name: "pay_type"
                }, null, 8, ["modelValue", "items"]),
                _hoisted_8,
                vue_2.withDirectives(vue_2.createElementVNode("textarea", {
                    class: "textarea",
                    placeholder: form.value.comment.placeholder,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((form.value.comment.value) = $event); })
                }, null, 8, _hoisted_9), [
                    [vue_2.vModelText, form.value.comment.value]
                ]),
                _hoisted_10,
                (formErrors.value.length)
                    ? (vue_2.openBlock(), vue_2.createElementBlock("div", _hoisted_11, [
                        (vue_2.openBlock(true), vue_2.createElementBlock(vue_2.Fragment, null, vue_2.renderList(formErrors.value, function (error) {
                            return (vue_2.openBlock(), vue_2.createElementBlock("div", null, vue_2.toDisplayString(error), 1));
                        }), 256))
                    ]))
                    : vue_2.createCommentVNode("", true)
            ], 40, _hoisted_1));
        };
    }
});
